import React from 'react';
import './ArchitecturalServices.css'; 
import useScrollToTop from '../components/useScrollToTop';
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/kitchen_modern_classic.webp';
import {FaFileAlt, FaHome, FaDraftingCompass, FaBuilding, FaExpandArrowsAlt, FaCarSide, FaSun, FaHammer, FaUserCheck, FaClock, FaHardHat, FaSearch, FaCheckDouble, FaHandshake } from 'react-icons/fa'; 
import Button from '../components/Button';

const ResidentialConstruction = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Residential Construction"
                description="Building your dream home is a significant milestone. At Housekaar, we specialize in residential construction, delivering high-quality homes that reflect your unique style and needs."
            />
            <div className="architectural-services-page">
                <section className="services-overview">
                    <h2>Our Residential Construction Services</h2>
                    <p>We offer a comprehensive range of residential construction services to bring your vision to life.</p>
                    <ul className="services-list">
                        <li><FaHome className="service-icon" /> <strong>Custom Home Building:</strong> Designing and constructing bespoke homes meticulously tailored to your individual vision, lifestyle, and preferences.</li>
                        <li><FaBuilding className="service-icon" /> <strong>Spec Home Construction:</strong> Building high-quality, move-in ready homes featuring modern designs, desirable amenities, and attention to detail.</li>
                        <li><FaExpandArrowsAlt className="service-icon" /> <strong>Home Additions:</strong> Seamlessly expanding your existing home with new rooms, extensions, and renovations to accommodate your evolving needs.</li>
                        <li><FaCarSide className="service-icon" /> <strong>Garage Construction:</strong> Building functional and aesthetically pleasing detached or attached garages for vehicle storage, workshop space, or additional storage.</li>
                        <li><FaSun className="service-icon" /> <strong>Outdoor Living Spaces:</strong> Creating inviting and functional outdoor areas, including patios, decks, pergolas, and outdoor kitchens, to enhance your living experience.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Our Residential Construction</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="service-icon"><FaHammer /></div>
                            <h3>Quality Craftsmanship</h3>
                            <p>Ensuring that every aspect of the construction process is executed with precision, skill, and attention to detail, meeting our stringent quality standards.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaHandshake /></div>
                            <h3>Personalized Service</h3>
                            <p>Working closely with you throughout the entire journey, from initial consultation to final walkthrough, to understand your unique needs, preferences, and budget.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaClock /></div>
                            <h3>Timely Completion</h3>
                            <p>Adhering to agreed-upon project timelines and diligently managing the construction schedule to ensure your home is completed efficiently.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaCheckDouble /></div>
                            <h3>High-Quality Materials</h3>
                            <p>Utilizing durable, premium-grade materials and partnering with trusted suppliers to ensure the longevity, structural integrity, and aesthetic appeal of your home.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>We follow a transparent and collaborative process to build your dream home.</p>
                    <ol className="process-list">
                        <li><FaDraftingCompass className="process-icon" /> <strong>Initial Consultation:</strong> Discussing your vision, goals, budget, and specific requirements for your new home or addition.</li>
                        <li><FaFileAlt className="process-icon" /> <strong>Design and Planning:</strong> Collaborating with architects and designers to develop detailed architectural plans and obtaining all necessary permits and approvals.</li>
                        <li><FaHardHat className="process-icon" /> <strong>Construction:</strong> Executing the construction phase with our team of skilled professionals, adhering to the highest standards of workmanship and safety.</li>
                        <li><FaSearch className="process-icon" /> <strong>Inspections:</strong> Conducting regular quality control inspections at critical stages of construction to ensure compliance with plans, codes, and our quality standards.</li>
                        <li><FaUserCheck className="process-icon" /> <strong>Final Walkthrough:</strong> Conducting a comprehensive review of the completed home with you to ensure your satisfaction before the final handover.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Let's Build Your Dream Home Together</h2>
                    <p>
                        Contact us today to schedule your initial consultation and discuss your residential construction project. We are excited to help you build the home of your dreams.
                    </p>
                    <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Contact Us</Button>
                </a>
                </section>
            </div>
        </>
    );
};

export default ResidentialConstruction;